import { FC, ChangeEvent } from 'react';

type SellUnitsStepperProps = {
  value: number;
  max: number;
  onChange: (value: number) => void;
  disabled?: boolean;
};

const SellUnitsStepper: FC<SellUnitsStepperProps> = ({
  value,
  max,
  onChange,
  disabled,
}) => (
  <div className="incentive-offer-sell-units-panel__stepper">
    <button
      type="button"
      className="incentive-offer-sell-units-panel__stepper-btn"
      onClick={() => onChange(value - 1)}
      disabled={disabled || value <= 0}
    >
      −
    </button>
    <input
      value={value}
      disabled={disabled}
      onChange={(e: ChangeEvent<HTMLInputElement>) =>
        onChange(Number(e.target.value.replace(/\D/g, '')) || 0)
      }
      className="incentive-offer-sell-units-panel__stepper-input tnum"
    />
    <button
      type="button"
      className="incentive-offer-sell-units-panel__stepper-btn"
      onClick={() => onChange(value + 1)}
      disabled={disabled || value >= max}
    >
      +
    </button>
  </div>
);

export default SellUnitsStepper;
